module.exports = "/images/vendor/flag-icon-css/flags/1x1/mf.svg?487f7bd7fd30eec81e74e5cf1f699833";